"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mmcq_1 = require("./mmcq");
exports.MMCQ = mmcq_1.default;
exports.WebWorker = null;
//# sourceMappingURL=index.js.map